import { useState } from "react";
import ListaPerguntaERespostaFormProduto from "../ListarPerguntaERespostaProduto";
import { ICadastrarPerguntaFormularioProduto } from "../../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import CadastrarPerguntasERespostasFormProduto from "../PerguntasERespostaFormProduto";

interface IFormularioModalProps {
    idFormularioProduto: number;
    ID_EMPREENDIMENTO: number;
}

export default function FormularioProdutoModal(props: IFormularioModalProps) {
    const [cadastrandoOuEditando, setCadastrandoOuEditando] = useState(true);
    const [perguntaSendoEditada, setPerguntaSendoEditada] = useState<
        ICadastrarPerguntaFormularioProduto | undefined
    >(undefined);

    return (
        <div>
            {cadastrandoOuEditando ? (
                <ListaPerguntaERespostaFormProduto
                    setPerguntaSendoEditada={setPerguntaSendoEditada}
                    setMostrarPerguntasERespostas={setCadastrandoOuEditando}
                    idFormularioProduto={props.idFormularioProduto}
                    ID_EMPREENDIMENTO={props.ID_EMPREENDIMENTO}
                />
            ) : (
                <CadastrarPerguntasERespostasFormProduto
                    idFormularioProduto={props.idFormularioProduto}
                    setPerguntaSendoEditada={setPerguntaSendoEditada}
                    perguntaERespostas={perguntaSendoEditada}
                    setMostrarPerguntasERespostas={setCadastrandoOuEditando}
                />
            )}
        </div>
    );
}
